export const ROOT = '/';
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const UI_COMPONENTS_PREFIX_PATH = '/ui-components';
export const PAGES_PREFIX_PATH = '/pages';
export const DOCS_PREFIX_PATH = '/docs';

export const Route = {
    // Dashboard
    DASHBOARD: '/home',

    // Authentication
    SIGN_IN: '/sign-in',

    // POS
    POS: '/create-sale',
    POS_NEW: '/cart',

    // Settings
    SETTINGS: '/settings',
    SETTINGS_INVOICE: '/settings/invoice',

    // Users and Roles
    USERS: '/users',
    USER_CREATE: '/users/create',
    USER_DETAILS: '/users/:id',
    USER_EDIT: '/users/:id/edit',

    ROLES: '/roles',
    ROLE_DETAILS: '/roles/:id',
    ROLE_CREATE: '/roles/create',

    // Wholesale Orders
    WHOLESALE_ORDER_REQUESTS: '/wholesale-orders/requests',
    WHOLESALE_ORDER_REQUEST_DETAILS: '/wholesale-orders/requests/:id',
    WHOLESALE_ORDER_CUSTOMERS: '/wholesale-orders/customers',
    WHOLESALE_ORDER_CUSTOMER_DETAILS: '/wholesale-orders/customers/:id',
    WHOLESALE_ORDER_DETAILS: '/wholesale-orders/orders/:id',

    // Products
    PRODUCTS: '/products',
    PRODUCT_CREATE: '/products/create',
    PRODUCT_CREATE_NEW: '/products/create/new',
    PRODUCT_BRANDS: '/brands',
    PRODUCT_GENERICS: '/generics',
    PRODUCT_TYPES: '/types',
    PRODUCT_STRENGTHS: '/strengths',
    PRODUCT_UNITS: '/units',

    // Stock
    STOCK_ALL_PRODUCTS: '/stocks',
    STOCK_LOW_PRODUCTS: '/stocks/low-stock',
    STOCK_OUT_PRODUCTS: '/stocks/stock-out',
    STOCK_EXPIRED_PRODUCTS: '/stocks/expired',
    STOCK_ADD: '/purchases/create',
    STOCK_PRODUCT_DETAILS: '/stocks/products/:product_variation_id',

    // Adjustments
    ADJUSTMENT_EXPIRED_PRODUCTS: '/adjustments/expired',
    ADJUSTMENT_EXPIRED_PRODUCT_DETAILS: '/adjustments/expired/:id',
    ADJUSTMENT_EXPIRED_PRODUCT_CREATE: '/adjustments/expired/create',

    ADJUSTMENT_STOCKS: '/adjustments/stocks',
    ADJUSTMENT_STOCK_CREATE: '/adjustments/stocks/create',

    // Expenses
    EXPENSES: '/expenses',
    EXPENSES_CREATE: '/expenses/create',
    EXPENSE_CATEGORIES: '/expenses/categories',
    EXPENSE_CATEGORY_CREATE: '/expenses/categories/create',

    // Purchase
    PURCHASES: '/purchases',
    PURCHASE_DETAILS: '/purchases/:id',
    PURCHASE_CREATE: '/purchases/create',

    // New Purchase Route - Updated UI
    PURCHASE_CREATE_NEW: '/purchases/create/new',
    PURCHASE_RETURNS: '/purchases/returns',
    PURCHASE_RETURN_DETAILS: '/purchases/returns/:id',
    PURCHASE_RETURN_CREATE: '/purchases/returns/create',

    // Pre Purchases
    PRE_PURCHASES: '/purchases/pre-purchases',
    PRE_PURCHASE_DETAILS: '/purchases/pre-purchases/:id',
    PRE_PURCHASE_CREATE: '/purchases/pre-purchases/create',

    // Suppliers
    SUPPLIERS: '/suppliers',
    SUPPLIER_DETAILS: '/suppliers/:id',

    // Customers
    CUSTOMERS: '/customers',
    CUSTOMER_DETAILS: '/customers/:id',

    // Sales
    SALES: '/sales',
    SALE_DETAILS: '/sales/:id',

    // Sales Returns
    SALES_RETURNS: '/sales-returns',
    SALES_RETURN_DETAILS: '/sales-returns/:id',
    SALES_RETURN_CREATE: '/sales-returns/create',

    // Accounting
    ACCOUNTING_TRANSACTIONS: '/accounting/transactions',
    ACCOUNTING_PROFIT_AND_LOSS: '/accounting/profit-and-loss',
    ACCOUNTING_BALANCE_SHEET: '/accounting/balance-sheet',

    // Reports
    REPORTS_PROFIT_AND_LOSS: '/reports/profit-and-loss',
    REPORTS_ALL_TRANSACTIONS: '/reports/all-transactions',
    REPORTS_PURCHASE: '/reports/purchase-report',
    REPORTS_SALES: '/reports/sales-report',
    REPORTS_CUSTOMERS: '/reports/customer-reports',
    REPORTS_SUPPLIERS: '/reports/supplier-reports',
    REPORTS_STOCK: '/reports/stock-reports',
    REPORTS_STOCK_ADJUSTMENT: '/reports/stock-adjustment-reports',
    REPORTS_PURCHASE_PAYMENT: '/reports/purchase-payment-reports',
    REPORTS_SALE_PAYMENT: '/reports/sale-payment-reports',
    REPORTS_EXPENSE: '/reports/expense-reports',
    REPORTS_DAILY: '/reports/daily-reports',
    REPORTS_REGISTER: '/reports/register-reports',
    REPORTS_ACTIVITY_LOGS: '/reports/activity-logs',
    CASH_BOX: '/cash-box',

    // Notifications
    NOTIFICATIONS: '/notifications',
} as const;
